var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, valueIsEmpty } from '@shapeable/utils';
import { FieldContainer } from './field-container';
import { useFormFieldComponents } from '../hooks/use-form-field-components';
import { includes, omit } from 'lodash';
import { useFormState } from '../hooks/use-form-state';
var cls = classNames('form-v2');
export var FormV2DefaultProps = {
  fields: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FieldsStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FormStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: 0;\n    padding-top: 0;\n  "], ["\n    margin-top: 0;\n    padding-top: 0;\n  "])))
});
var FieldStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HiddenSubmitStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Form: styled.form(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Fields: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FieldsStyles),
  FieldContainer: styled(FieldContainer)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  HiddenSubmit: styled.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HiddenSubmitStyles)
};
export var Form = function (props) {
  var className = props.className,
    fields = props.fields,
    name = props.name,
    isChromeless = props.isChromeless;
  var formFieldComponents = useFormFieldComponents();
  // form state
  var formState = useFormState(name, {
    onChange: props.onChange
  });
  // we need a flag to indicate if the validate effect should run
  // we don't want to run a form "change" effect initially when the form is first created
  var _a = __read(React.useState(false), 2),
    shouldValidate = _a[0],
    setShouldValidate = _a[1];
  var handleSubmit = function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (props.onSubmit) {
      props.onSubmit({
        event: event,
        fields: formState.fields
      });
    }
  };
  var handleKeyDown = function (event) {
    if (event.key === 'Escape' && props.onEscape) {
      props.onEscape();
    }
  };
  // setup a validator effect
  React.useEffect(function () {
    if (!shouldValidate) {
      return;
    }
    var isValid = fields.every(function (field) {
      var _a, _b;
      var fieldIsValid = ((_a = formState.fields[field.name]) === null || _a === void 0 ? void 0 : _a.isValid) !== false;
      if (!fieldIsValid) {
        return false;
      }
      // if the field is not required, it's valid
      if (!field.required) {
        return true;
      }
      // if the field is required, it must have a value
      return !valueIsEmpty((_b = formState.fields[field.name]) === null || _b === void 0 ? void 0 : _b.value);
    });
    formState.patch({
      isValid: isValid
    });
  }, [formState.fields]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Form, {
    method: "post",
    /* @ts-ignore */
    onKeyDown: handleKeyDown,
    onSubmit: handleSubmit
  }, fields.map(function (field) {
    var _a;
    var Component = formFieldComponents[field.type];
    // setup a default change handler
    var handleChange = function (result) {
      var _a, e_1, _b;
      setShouldValidate(true);
      var patch = (_a = {}, _a[field.name] = omit(result, 'extraState'), _a);
      if (result.extraState) {
        try {
          for (var _c = __values(Object.entries(result.extraState)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = __read(_d.value, 2),
              fieldName = _e[0],
              fieldState = _e[1];
            patch[fieldName] = fieldState;
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
      formState.patchFields(patch);
      // if there was a specific handler, call it too.
      if (field.onChange) {
        field.onChange(result);
      }
    };
    var isHidden = includes(['hidden', 'nameHidden', 'id'], field.type);
    var isMultiple = field.type === 'linkedMultiple';
    // limit the fields passed in as the new form spec is not type-compatible (old spec needs to be deprecated)
    // const fieldContainerFieldProp = pick(field, ['name', 'label', 'description', 'required']);
    var component = React.createElement(Component
    // note that the spread here will pass extra fields through from EntityFormField too. 
    , __assign({
      // note that the spread here will pass extra fields through from EntityFormField too. 
      disabled: props.disabled,
      isMultiple: isMultiple,
      isChromeless: isChromeless
    }, field, {
      options: field.options || {},
      value: (_a = formState.fields[field.name]) === null || _a === void 0 ? void 0 : _a.value,
      onChange: handleChange,
      required: field.required
    }));
    return isHidden ? component : isChromeless ? component : React.createElement(My.FieldContainer, {
      key: field.name,
      field: field
    }, component);
  }), React.createElement(My.HiddenSubmit, {
    type: "submit",
    tabIndex: -1
  }, "Submit")));
};
Form.cls = cls;
Form.defaultProps = FormV2DefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;